import { FieldError, HStack, Text, VStack } from 'aos-ui-universal'
import React, { FC, ReactNode } from 'react'

interface NumberRowFieldProps {
    prefixLabel: string
    suffixLabel?: string
    error?: string
    className?: string
    children: ReactNode
}

export const NumberRowField: FC<NumberRowFieldProps> = ({
    prefixLabel,
    suffixLabel,
    error,
    className,
    children,
}) => (
    <VStack className={className ?? 'shrink-0 gap-1'}>
        <HStack className='shrink-0 items-center gap-2'>
            <Text size='body' tone='default'>
                {prefixLabel}
            </Text>
            {children}
            {suffixLabel ? (
                <Text size='body' tone='default'>
                    {suffixLabel}
                </Text>
            ) : null}
        </HStack>
        {error ? <FieldError>{error}</FieldError> : null}
    </VStack>
)
